module.exports = __webpack_public_path__ + "static/media/formula.77948196.svg";